import React from 'react';
import ReadOther from './Read';
import WriteOther from './Write';

export default function Other(props) {
  const { isUpdate, inputChange, dataProduct } = props; //data Products

  return isUpdate ? (
    <WriteOther inputChange={inputChange} dataProduct={dataProduct} />
  ) : (
    <ReadOther dataProduct={dataProduct} />
  );
}
